"use client"
import { useState } from "react"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Card, CardContent } from "@/components/ui/card"

export function NewsletterSection() {
  const [email, setEmail] = useState("")
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle")
  const [message, setMessage] = useState<string>("")

  const onSubscribe = async () => {
    // simple email validation
    const isValid = /[^\s@]+@[^\s@]+\.[^\s@]+/.test(email)
    if (!isValid) {
      setStatus("error")
      setMessage("Please enter a valid email address.")
      return
    }
    setStatus("loading")
    setMessage("")
    try {
      // Placeholder subscription; integrate your API endpoint here
      await new Promise((res) => setTimeout(res, 800))
      setStatus("success")
      setMessage("You're in! We’ll send weekly insights to your inbox.")
      setEmail("")
    } catch (e) {
      setStatus("error")
      setMessage("Something went wrong. Please try again.")
    }
  }

  return (
    <section id="newsletter-section" className="subscribe-section relative py-24 text-white">
      {/* Fluid background blobs */}
      <div className="blob blob-1" />
      <div className="blob blob-2" />
      <div className="blob blob-3" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="max-w-4xl mx-auto">
          <Card className="subscribe-card">
            <CardContent className="p-10 md:p-14 text-center">
              <h2 className="text-3xl lg:text-4xl text-white font-light tracking-tight">
                Stay Ahead with Next-Gen Health Insurance Intelligence
              </h2>
              <p className="mt-4 text-base md:text-lg text-white/80">
                Stay ahead with expert tips, regulatory updates, and proven strategies used by leading health insurers worldwide.
              </p>
              <div className="mt-8 flex flex-col sm:flex-row gap-4 max-w-xl mx-auto">
                <Input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email address"
                  className="flex-1 bg-white/10 text-white placeholder:text-white/60 backdrop-blur-md border-white/20 focus:ring-2 focus:ring-[#1a85ca]"
                />
                <Button
                  onClick={onSubscribe}
                  disabled={status === "loading"}
                  className="relative bg-[#1a85ca] hover:bg-[#1a85cc] transition-colors px-6 py-2 rounded-full"
                >
                  {status === "loading" ? "Subscribing…" : "Subscribe"}
                </Button>
              </div>
              {message && (
                <p
                  className={
                    "mt-4 text-sm " +
                    (status === "success" ? "text-emerald-300" : status === "error" ? "text-red-300" : "text-white/70")
                  }
                >
                  {message}
                </p>
              )}
              <p className="mt-3 text-xs md:text-sm text-white/60">Join 1,000+ healthcare executives. Unsubscribe anytime.</p>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  )
}
